import { AxiosResponse } from 'axios';
import { ClientEventsApi } from '../apis';

export const markFeature = (
  projectId: string,
  featureType: 'access' | 'add',
  serviceName: string,
  defaultContent: string | undefined
) => {
  try {
    const featureId = selectFeatureId(serviceName, featureType);
    const featureName = `${featureType} ${featureId}`;
    ClientEventsApi.postFeature(
      projectId,
      featureId,
      featureName,
      defaultContent
    ).catch(error => console.error(error));
  } catch (error) {
    console.log(error);
  }
};

export const markException = (response: AxiosResponse | undefined) => {
  ClientEventsApi.postException(response).catch(error => console.error(error));
};

const selectFeatureId = (
  serviceName: string,
  featureType: 'access' | 'add'
): string => {
  const featureId = featureIds[featureType][serviceName];
  if (!featureId) {
    throw new Error(
      `Feature ID not found. Service name ${serviceName} is invalid`
    );
  }
  return featureId;
};

const featureIds = {
  access: {
    'ProjectWise Web Connections': 'D58A586B-7057-4074-89A0-DB394389FB7B',
    'Deliverables Management': '97ebbe88-8f94-45fe-8c89-b75cca3ce8dd',
    'Project Insights': 'da947c1a-e327-45d7-9b6a-dd5388714853',
    'Issue Resolution': '433d7512-8058-4203-95a5-657a7addabc9',
    'ProjectWise 365': '0F307B03-3EC1-4FDD-B792-0D0D49D7F40E',
    Forms: '02ec51b4-6412-4eac-8c21-8629ba421fd7',
    'Field Data Management': '02ec51b4-6412-4eac-8c21-8629ba421fd7',
  },
  add: {
    'ProjectWise Web Connections': '40D3AE8A-111F-4D3B-AF94-CF5AA87646C8',
    'Deliverables Management': 'c526e8d0-5a8c-4686-aef7-290706ea91b8',
    'Project Insights': '90176f86-a678-40da-bbf8-eec1354a1131',
    'Issue Resolution': '9bfd2340-2416-49c4-98f7-d1732832172f',
    'ProjectWise 365': 'FA8ECA6C-8E29-4DEC-8CCB-C3730DDED988',
    Forms: '5b58d35b-75d8-4b7c-88fa-0fb40e9c5b23',
    'Field Data Management': '5b58d35b-75d8-4b7c-88fa-0fb40e9c5b23',
  },
};
